import { useLocales } from '@shared/locales'
import { Flex, Modal, theme } from 'antd'

import { InfoCircle } from 'iconsax-react'

import type { ModalProps } from 'antd'

type Props = {
  header?: React.ReactNode
  onSuccess: () => void
  onCancel: () => void
} & ModalProps

export const ConfirmModal = ({
  header,
  onSuccess,
  onCancel,
  children,
  ...props
}: Props) => {
  const { t } = useLocales()
  const { token } = theme.useToken()

  return (
    <Modal
      title={
        <Flex align="center" gap={8}>
          <InfoCircle variant="Bold" color={token.orange5} size={24} />
          {header || t('confirm.are_you_sure')}
        </Flex>
      }
      onCancel={onCancel}
      centered
      cancelText={t('buttons.cancel')}
      okText={t('buttons.yes')}
      onOk={onSuccess}
      {...props}
    >
      {children || t('confirm.are_you_sure_description')}
    </Modal>
  )
}
